<div *ngIf="true" class="flex-fill d-flex flex-column p-2">
    <div class="btn-toolbar">
        <button class="btn btn-success me-2" (click)="save(true)">Send Email</button>
        <button class="btn btn-danger" (click)="cancel()">Cancel</button>
    </div>
    <dx-form class="px-3" [formData]="payment" [colCount]="4" validationGroup="invoiceValidationGroup">
        <dxi-item itemType="group" caption="Dealer" [disabled]="readOnly">
            <dxi-item *ngIf="dealer">
                <div *dxTemplate>
                    <h3 class="mt-0 mb-1">{{ dealer.displayName }}</h3>
                    <div>{{ dealer.billAddress1 }}</div>
                    <div>{{ dealer.billAddress2 }}</div>
                    <div>
                        {{ dealer.billCity ? dealer.billCity + ',' : '' }}
                        {{ dealer.billState }}
                        {{ dealer.billZip }}
                    </div>
                </div>
            </dxi-item>
        </dxi-item>

        <dxi-item itemType="group" caption="Totals">
            <dxi-item *ngIf="key === 'new'" [label]="{ text: 'Beginning Balance' }">
                <div *dxTemplate>
                    <dx-number-box [value]="balance" [format]="{ type: 'currency', precision: 2 }" [disabled]="readOnly"></dx-number-box>
                </div>
            </dxi-item>
            <dxi-item [label]="{ text: 'Requested Amount' }">
                <div *dxTemplate>
                    <dx-number-box [(value)]="amountReceived" [step]="0" [readOnly]="true" [format]="{ type: 'currency', precision: 2 }" [disabled]="readOnly"></dx-number-box>
                </div>
            </dxi-item>
            <dxi-item [label]="{ text: 'Remaining Balance' }">
                <div *dxTemplate>
                    <dx-number-box [value]="balance - amountReceived" [step]="0" [readOnly]="true" [format]="{ type: 'currency', precision: 2 }" [disabled]="true"></dx-number-box>
                </div>
            </dxi-item>
        </dxi-item>
        <dxi-item itemType="group" caption="Summary" [colSpan]="2">
            <dxi-item>
                <div *dxTemplate>
                    <div class="requested-amount">Requested Amount: {{ amountReceived | currency }}</div>
                </div>
            </dxi-item>
        </dxi-item>
    </dx-form>
    <div class="mt-4 d-flex flex-fill">
        <dx-data-grid
            #dataGrid
            *ngIf="paymentLines"
            keyExpr="id"
            height="95%"
            class="p-2 me-4 mb-2 flex-fill grid-fill ach-request-grid"
            [dataSource]="paymentLines"
            [showBorders]="true"
            [showRowLines]="true"
            [hoverStateEnabled]="true"
            (onToolbarPreparing)="onToolbarPreparing($event)"
            (onRowPrepared)="rowPrepare($event)"
            (onRowDblClick)="rowDoubleClick($event)"
            (onRowUpdated)="rowUpdated($event)"
            [customizeColumns]="customizeColumns"
        >
            <dxi-column dataField="lineNumber" caption="No." [visible]="true" width="80" [sortIndex]="1" [sortOrder]="'asc'"></dxi-column>
            <dxi-column dataField="generatedDescription" caption="Description" width="185" cellTemplate="descriptionTemplate"></dxi-column>
            <dxi-column dataField="invoiceDate" caption="Date" width="100" [format]="{ type: 'shortDate' }"></dxi-column>
            <dxi-column dataField="invoiceDueDate" caption="Due Date" width="100" [format]="{ type: 'shortDate' }"></dxi-column>
            <dxi-column dataField="invoiceAmount" [format]="{ type: 'currency', precision: 2 }" width="150"></dxi-column>
            <dxi-column dataField="startingBalance" [format]="{ type: 'currency', precision: 2 }" [visible]="key === 'new'" width="150"></dxi-column>
            <dxi-column dataField="remainingBalance" [format]="{ type: 'currency', precision: 2 }" width="150"></dxi-column>
            <dxi-column dataField="amount" [format]="{ type: 'currency', precision: 2 }" width="150" [editorOptions]="{ step: 0 }"></dxi-column>
            <!-- <dxi-column dataField="relatedPaymentIds" caption="Related Payments" width="150" cellTemplate="relatedPaymentTemplate"></dxi-column> -->
            <!-- <dxi-column dataField="creditAmount" [format]="{ type: 'currency', precision: 2 }" width="100"></dxi-column> -->
            <dxi-column></dxi-column>

            <div *dxTemplate="let cell of 'descriptionTemplate'">
                <a [routerLink]="[]" (click)="openInvoice(cell.data.invoiceId)">{{ cell.value || '' }}</a>
            </div>

            <div *dxTemplate="let cell of 'relatedPaymentTemplate'">
                <span *ngFor="let paymentId of cell.data.relatedPaymentIds; index as i" class="pe-1">
                    <a *ngIf="cell" [routerLink]="[]" (click)="openPayment(paymentId)">#{{ paymentId + (i + 1 < cell.data.relatedPaymentIds.length ? ', ' : '') }}</a>
                </span>
            </div>
            <dxo-summary>
                <dxi-total-item column="invoiceAmount" summaryType="sum" displayFormat="{0}" [valueFormat]="{ type: 'currency', precision: 2 }"></dxi-total-item>
                <dxi-total-item column="amount" summaryType="sum" displayFormat="{0}" [valueFormat]="{ type: 'currency', precision: 2 }"></dxi-total-item>
            </dxo-summary>

            <dxo-editing [mode]="'cell'" [allowUpdating]="true"></dxo-editing>
            <dxo-selection [mode]="'none'"></dxo-selection>
            <dxo-state-storing [enabled]="true" type="localStorage" storageKey="ach-invoice-lines-grid"></dxo-state-storing>

            <div *dxTemplate="let data of 'toolbarButtons'"></div>
            <div *dxTemplate="let data of 'toolbarText'">
                <div class="me-3 d-flex flex-row">
                    <em><strong>Doubleclick row to toggle amount</strong></em>
                    <div class="ms-4 me-3"><span class=" mt-0 color-legend with-border pending-ach"></span> - Pending ACH</div>
                </div>
            </div>
        </dx-data-grid>
    </div>
</div>
